import React from 'react';
import {Typography, withStyles} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {GreatTable} from 'components/common';

const useTableStyles = withStyles({
  tableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  titleTableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'left',
    marginLeft: 20,
  },
  optionTableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'left',
    marginLeft: 20,
  },
  dot: {
    height: 5,
    width: 5,
    marginRight: 10,
    borderRadius: '50%',
    backgroundColor: '#bbb',
    display: 'inline-block',
  },
});

const QuestionTable = useTableStyles(({classes, ...restProps}) => {
  return (
    <GreatTable
      {...restProps}
      itemName="question"
      getFieldsMapping={(question) => ({
        title: question.title,
        options: question.singleSelect.options,
        answer: question.answer,
      })}
      getFieldsSettings={() => ({
        title: {
          fieldText: 'Title',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.titleTableCell,
          formatData: (cell) => <Typography>{cell}</Typography>,
        },
        options: {
          fieldText: 'Options',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.optionTableCell,
          formatData: (cell) => (
            <div>
              {cell
                .filter((option) => !isEmpty(option))
                .map((option, index) => (
                  <Typography key={index}>
                    <span className={classes.dot} />
                    {option}
                  </Typography>
                ))}
            </div>
          ),
        },
        answer: {
          fieldText: 'Answer',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
      })}
    />
  );
});

export default QuestionTable;
